import api from '@/js/services/api';

export default {
    login(form) {
        return api().post(`/login`, form)
    },

    applicationLogin(form) {
        return api().post(`/employee/check-user`, form)
    },

    loginMasterAdmin(form) {
        return api().post(`/master-admin/login`, form)
    },

    resetPassword(form) {
        return api().post(`/master-admin/password-recovery`, form)
    },

}
